/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentTypeConfigurationDetailed { 
    id?: number;
    tenantId?: number;
    wakandiId?: string | null;
    paymentClientId?: string | null;
    paymentClientSecret?: string | null;
    mpin?: string | null;
}

